import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { StatsStrip } from './components/StatsStrip';
import { PainCarousel } from './components/PainCarousel';
import { Contents } from './components/Contents';
import { Bonuses } from './components/Bonuses';
import { Risks } from './components/Risks';
import { Pricing } from './components/Pricing';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-forest-900 font-sans" data-id="element-0" data-mp="31brzvakwgrl4">
      <Header data-id="element-1" data-mp="2wk08wyxu0jug" />
      <main data-id="element-2" data-mp="2wk9xqj754kyk">
        <Hero data-id="element-3" data-mp="2wjqgl4pbe0ll" />
        <StatsStrip data-id="element-4" data-mp="2wj8cjlweui34" />
        <PainCarousel data-id="element-5" data-mp="2wip7v6vrtq71" />
        <Contents data-id="element-6" data-mp="2wi5pxq64f1t0" />
        <Bonuses data-id="element-7" data-mp="28tw6guwdqq51" />
        <Risks data-id="element-8" data-mp="28te198rqp1kz" />
        <Pricing data-id="element-9" data-mp="28t4j27cxrypu" />
        <Faq data-id="element-10" data-mp="28skzynbjv4a8" />
      </main>
      <Footer data-id="element-11" data-mp="23vci6nubd29i" />
    </div>;
}